import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { ShowIfHttpError } from '@certemy/common';
import { Observable } from 'rxjs';
import { createQueryParam, buildQueryParams } from 'utils/helpers';
import {
  ShareWorkflowRequest,
  ShareWorkflowList,
  ShareWorkflowListQueryParam,
  UnShareWorkflowRequest,
} from './workflow-share.interface';

@Injectable()
export class SharingWorkflowService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('Cannot receive organization for share')
  getAvailableForSharingOrganization(params): Observable<ShareWorkflowList> {
    const queryParams = this.getQueryParams(params);
    return this.http.get(`/organization/child/${queryParams}`);
  }

  @ShowIfHttpError('Cannot receive organization for unshare')
  getOrganizationWithSharedWorkflow(workflowId: number, params): Observable<ShareWorkflowList> {
    const queryParams = this.getQueryParams(params);
    return this.http.get(`/organization/child/${workflowId}/${queryParams}`);
  }

  private getQueryParams({ limit, search, offset, filters }: ShareWorkflowListQueryParam): string {
    return buildQueryParams(
      [
        limit && createQueryParam('limit', limit),
        offset && createQueryParam('offset', offset),
        search && createQueryParam('search', search),
        filters && createQueryParam('filters', filters),
      ].filter(Boolean),
    );
  }

  @ShowIfHttpError('Cannot share workflows')
  shareWorkflows(data: ShareWorkflowRequest) {
    return this.http.post('/shared-workflow/share', data);
  }
  @ShowIfHttpError('Cannot unshare workflows')
  unShareWorkflows(data: UnShareWorkflowRequest) {
    return this.http.post('/shared-workflow/unshare', data);
  }
}
